import { defineComponent as t, createElementBlock as n, openBlock as o, createVNode as s, createElementVNode as r, unref as a } from "vue";
import { ScalarIconMagnifyingGlass as i } from "@scalar/icons";
const c = {
  class: "sidebar-search",
  type: "button"
}, u = /* @__PURE__ */ t({
  __name: "FindAnythingButton",
  setup(p) {
    return (l, e) => (o(), n("button", c, [
      s(a(i), {
        class: "size-3",
        weight: "bold"
      }),
      e[0] || (e[0] = r("span", {
        class: "sidebar-search-input",
        type: "text"
      }, " Find Anything ", -1))
    ]));
  }
});
export {
  u as default
};
